
/**
 * @ngdoc directive
 * @name searchbar
 *
 * @description
 * Search input form
 */
module.directive('searchbar', ['$timeout', function ($timeout) {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', '$state', 'drupal', 'moment', '$document', '$timeout', 'utils', function ($scope, $state, drupal, moment, $document, $timeout, utils) {
            $scope.opened = 0;
            $scope.pending = false;

            $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

            $scope.ismobile = document.body.clientWidth < 480;

            /* link to anchor handler */
            $scope.scrollTo = function (dest) {
                if ($scope.ismobile) {
                    var element = angular.element(document.getElementById(dest));
                    // use timeout to prevent scroll before digest
                    $timeout(function () {
                        $document.scrollToElement(element, 30, 250);
                    }, 0);
                }
            };

            $scope.searchform = {
                query: ''
            };

            $scope.availableDates = [];
            drupal.getAllSimpleInternships().then(function(internships) {
                $scope.availableDates = internships.map(function(internship) {
                    return moment(internship.startDate, ["YYYY-MM-DD"]).format("MM/DD/YYYY");
                }).filter(function(date, index, array) {
                    return array.indexOf(date) === index;
                });
            });

            drupal.getCriteria().then(function(criteria) {
                var keywords = [];
                criteria.filters.activity.options.forEach(function(activity) {
                    if (activity.name !== 'Gestion' && activity.name !== 'Kitesurf' && activity.name !== 'Kayak de mer' && activity.name !== 'Aucune') {
                        keywords.push({label: activity.name, id: activity.name, type: 'activity'})
                    }
                });
                criteria.filters.basename.options.forEach(function(base) {
                    if(base.name !== 'Autre') {
                        keywords.push({label: base.name, id: base.name, type: 'location'})
                    }
                });

                // keywords
                $scope.keywords = {
                    limit: 0,
                    selected: [],
                    list: keywords
                };

                var targets = [];
                criteria.filters.audience.options.forEach(function(audience) {
                    targets.push({label: audience.name, id: audience.name})
                });

                // targets
                $scope.targets = {
                    limit: 0,
                    selected: [],
                    list: targets
                };

		        // $scope.target.selected = $scope.target.list[0];

                var levels = [];
                criteria.filters.level.options.forEach(function(level) {
                    levels.push({label: level.label, id: level.name})
                });

                // levels
                $scope.criteria = {
                    date: '',
                    level: null,
                    list: levels
                };
                $scope.criteria.level = null;
            });

            utils.calendarTrad();


            // launch search
            $scope.search = function (isValid) {
                $scope.pending = true;
                $scope.opened = 0;

                if (isValid) {

                    var search = $scope.searchform.query;
                    var targets = [];
                    var activities = [];
                    var regions = [];

                    $scope.keywords.selected.forEach(function(keyword) {
                        if (keyword.type === 'location') {
                            regions.push(keyword.id);
                        }
                        else if (keyword.type === 'activity') {
                            activities.push(keyword.id);
                        }
                    });

                    if ($scope.targets.selected.length > 0) {
                        targets = $scope.targets.selected.map(function (t) { return t.id; });
                    } else {
                        targets = undefined;
                    }


                    // redirect to internship state (request is made there)
                    $state.go('internship.list', {
                        search: search,
                        activity: activities,
                        region: regions,
                        audience: targets,
                        level: $scope.criteria.level && $scope.criteria.level.id,
                        date: $scope.criteria.date ? moment($scope.criteria.date, ["DD/MM/YYYY"]).format("DD-MM-YYYY") : null
                    });
                } else {
                    // not valid
                    $scope.pending = false;
                }

            };
        }],
        link: function ($scope, element) {
            // open/close dropdown menu
            $scope.toogleMenu = function (id) {
                if (!$scope.pending && $scope.opened === id) {
                    $scope.opened = 0;
                } else {
                    $scope.opened = id;
                    // // autoclose menu timer
                    // $scope.hidePanels();
                }
                var idest = id ? '-' + id : '';
                $scope.scrollTo('searchbarMenu' + idest);
            };

            // fullfiled keyword field (show "..." if there is no more place to display keywords)
            $scope.itemLimiter = function (type) {
                var i;
                var limit = 0;
                var container = element[0].querySelector('.aqua-searchbar--input-search--' + type);
                var availableWidth = container.getBoundingClientRect().width;
                var childrens = container.querySelectorAll('.aqua-searchbar--input--keyword');
                var childrensWidth = 0;

                for (i = 0; i < childrens.length; i += 1) {
                    childrens[i].classList.remove('is-hidden');
                    childrensWidth += childrens[i].getBoundingClientRect().width + 40;
                    if (childrensWidth < availableWidth) {
                        limit = i + 1;
                    } else {
                        childrens[i].classList.add('is-hidden');
                    }
                }
                if (type === 'keywords') {
                    $scope.keywords.limit = limit;
                } else {
                    $scope.targets.limit = limit;
                }
                $scope.$digest();
            };

            // Select/Unselect keyword
            $scope.toggleItem = function (item, items, type) {
                var i;
                item.selected = !item.selected;
                // if selected, add to selected list display
                if (item.selected) {
                    items.selected.push(item);
                }
                // clean list of selected keyword
                for (i = items.selected.length - 1; i >= 0; i -= 1) {
                    if (!items.selected[i].selected) {
                        items.selected.splice(i, 1);
                    }
                }
                $timeout(function () {
                    $scope.itemLimiter(type);
                });
            };
        },
        templateUrl: 'src/components/searchbar/searchbar.html'
    };
}]);
